import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ResetSessionState } from 'app/states/session/session.actions';
import { StoreCurrentUsers, StoreUsersForCases } from './users.actions';
import { UserService } from 'app/_services';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

export interface UsersModel {
  currentUsers: any[];
  usersForCases: any[];
}

const DEFAULTS: UsersModel = {
  currentUsers: [],
  usersForCases: []
};

@State<UsersModel>({
  name: 'users',
  defaults: DEFAULTS,
})
@Injectable()
export class UsersState {

  @Selector()
  static currentUsers(state: UsersModel) {
    return state.currentUsers;
  }

  @Selector()
  static usersForCases(state: UsersModel) {
    return state.usersForCases;
  }

  constructor(
    private userService: UserService
  ) {}

  @Action(StoreCurrentUsers)
  storeCurrentUsers(context: StateContext<UsersModel>, action: StoreCurrentUsers) {
    return this.userService.getByCustomerId(action.currentCustomerId).pipe(
      tap((usersResult: any[]) => {
        context.patchState({
          currentUsers: usersResult,
        });
      }),
    );
  }

  @Action(StoreUsersForCases)
  storeUsersForCases(context: StateContext<UsersModel>, action: StoreUsersForCases) {
    return this.userService.getUsersForCases(action.currentCustomerId).pipe(
      tap((usersResult: any[]) => {
        context.patchState({
          usersForCases: usersResult
        });
      })
    );
  }

  @Action(ResetSessionState)
  resetSessionState(context: StateContext<UsersModel>) {
    context.setState({ ...DEFAULTS });
  }
}
